import { useTalent } from "../../../providers/TalentProvider";
import ProfileContainer from "../components/ProfileContainer";

const TalentProfilePortfolio = () => {
    const { talent } = useTalent();

    const keyClients = TB.sortBy(talent.key_clients, 'display_index');

    return (
        <ProfileContainer>
            <div id="portfolio" className="pb-6">
                <h4 className="text-bold font-xl pb-6">Portfolio</h4>

                <div className="flex gap-4 flex-wrap">
                    {keyClients.map(client => {
                        return (
                            <div key={client.id} className="bg-red-100 p-3">
                                <img style={{ maxWidth: 120, maxHeight: 120 }} className="mb-2" src={client.logo_path} />
                            </div>
                        )
                    })}
                </div>

                <p className="pt-4">Make these images modals with details?</p>
            </div>
        </ProfileContainer>
    )
}

export default TalentProfilePortfolio;